import { FloatingComment } from '@/components/shared/FloatingComment';
import { abyssColors } from '@/theme/colors';

type Props = {
  anchorEl: HTMLElement | null;
  onSubmit: () => void;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
  isEditing?: boolean;
};

export const KpiFloatingComment = ({
  anchorEl,
  onSubmit,
  onClose,
  value,
  onChange,
  loading = false,
  isEditing = false,
}: Props) => {
  return (
    <FloatingComment
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      placeholder={isEditing ? 'Edit comment...' : 'Add a comment...'}
      popoverProps={{
        slotProps: {
          paper: {
            sx: { ml: -8, border: `1px solid ${abyssColors.primary[200]}`, minWidth: '20vw' },
          },
        },
      }}
      textfieldProps={{
        multiline: true,
        placeholder: isEditing ? 'Edit comment...' : 'Add a comment...',
        disabled: loading,
      }}
      submitDisabled={!value.trim() || loading}
    />
  );
};
